import { Distribution } from '../stores/better-entity-store'

export const sentToInvestorDistributions = (distributions: Distribution[]): Distribution[] =>
  distributions.filter((distribution) => distribution.type !== 'recycled funds')

export const recycledDistributions = (distributions: Distribution[]): Distribution[] =>
  distributions.filter((distribution) => distribution.type === 'recycled funds')
